import { render, staticRenderFns } from "./tplList.vue?vue&type=template&id=3f694add&scoped=true&"
import script from "./tplList.vue?vue&type=script&lang=js&"
export * from "./tplList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f694add",
  null
  
)

export default component.exports